import DateBadge from '@containers/Campaigns/CallForDreams/components/DateBadge/DateBadge';

export default DateBadge;
